<template>
  <div class="app-offline">
    <el-tag effect="dark"
            type="warning"
            v-if="isOffline">
      {{ $t('OFFLINE.IS_OFFLINE.SHORT') }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'AppOffline',
  data () {
    return {
      isOffline: false
    }
  },
  created () {
    window.ononline = () => this.isOffline = false
    window.onoffline = () => this.isOffline = true
  }
}
</script>
